<template>
  <div class="operoo-student-management-config">
    <v-row no-gutters>
      <v-col cols="12">
        <span>Organization ID</span>
        <span class="text-red">*</span>
      </v-col>
      <v-col cols="12">
        <v-text-field
          id="txt_organizationId"
          v-model="form.organizationId"
          variant="solo"
          density="compact"
          placeholder="Organization ID"
          :error-messages="errors.organizationId"
          :disabled="serviceEnded"
          @update:model-value="onTextInput('organizationId', 'Organization ID')"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <span>API Key</span>
        <span class="text-red">*</span>
      </v-col>
      <v-col cols="12">
        <v-text-field
          id="txt_apiKey"
          v-model="form.apiKey"
          variant="solo"
          density="compact"
          placeholder="API Key"
          :error-messages="errors.apiKey"
          :disabled="serviceEnded"
          @update:model-value="onTextInput('apiKey', 'API Key')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OperooStudentManagementConfig',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    serviceEnded: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:config', 'update:valid'],

  data() {
    return {
      form: {
        organizationId: '',
        apiKey: ''
      },
      errors: {
        organizationId: [],
        apiKey: []
      }
    };
  },

  watch: {
    config: {
      immediate: true,
      handler() {
        this.applyConfig();
      }
    }
  },

  methods: {
    applyConfig() {
      const config = this.config || {};
      Object.keys(this.form).forEach((name) => {
        if (typeof config[name] !== 'undefined') {
          this.form[name] = config[name];
        }
      });

      this.$emit('update:valid', this.isValid());
    },

    onTextInput(name, label) {
      this.errors[name] =
        !this.form[name] || `${this.form[name]}`.length === 0 ? [`${label} is required`] : [];
      this.emitConfig();
    },

    emitConfig() {
      this.$emit('update:config', { ...this.form });
      this.$emit('update:valid', this.isValid());
    },

    isValid() {
      return Object.keys(this.form).every(
        (name) => this.form[name] && `${this.form[name].trim()}`.length > 0
      );
    }
  }
};
</script>
